<script setup>
import { onMounted, ref } from 'vue';
import { redirect_sso_token } from '../services/auth'

const loading = ref(true)
const status = ref('Preparing forum access...')

onMounted(async () => {
  try {
    status.value = 'Fetching authentication token...'
    
    let response = await redirect_sso_token()
    
    loading.value = false

    if (response.error) {
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: response.result?.error || 'Failed to get authentication token'
      })
      return 
    }

    // Extract the token from response.
    const tokenData = response.result?.data
    const token = tokenData?.token

    if (!token) {
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'No authentication token received'
      })
      return
    }

    // Redirect directly to the backend SSO init endpoint (server-side flow).
    status.value = 'Redirecting to forum...'
    const apiHost = process.env.VUE_APP_API_HOST || 'http://localhost:3001'
    window.location.replace(`${apiHost}/auth/discourse/init?token=${encodeURIComponent(token)}`)
    
  } catch (err) {
    loading.value = false
    Swal.fire({
      title: 'Error',
      icon: 'error',
      text: 'Failed to access forum. Please try again.'
    })
  }
})
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Forum"/>

    <div class="card forum-card">
      <div class="card-body text-center py-5">
        <!-- Loading State -->
        <div v-if="loading" class="loading-content">
          <div class="spinner-border text-primary mb-3" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <h5 class="text-muted">{{ status }}</h5>
          <p class="text-muted small">You will be redirected automatically</p>
        </div>

        <!-- Redirect Message -->
        <div v-else>
          <p class="text-muted">Redirecting to forum...</p>
        </div>
      </div>
    </div>
  </div>  
</template>

<style scoped>
.forum-card {
  max-width: 500px;
  margin: 2rem auto;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.loading-content {
  padding: 2rem;
}
</style>